import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EFeatureFlags } from "../../enums/EFeatureFlags";
import { RootState } from "@store/store";

interface IFeatureFlags {
  featureFlags: EFeatureFlags[];
}

const initialState: IFeatureFlags = {
  featureFlags: [],
};

const featureFlagsSlice = createSlice({
  name: "featureFlags",
  initialState,
  reducers: {
    setFeatureFlags: (state, action: PayloadAction<EFeatureFlags[]>) => {
      state.featureFlags = action.payload;
    },
  },
});

export const { setFeatureFlags } = featureFlagsSlice.actions;

export const selectFeatureFlags = (state: RootState): EFeatureFlags[] =>
  state.featureFlags.featureFlags;

export default featureFlagsSlice.reducer;
